export const p1 = {
  Explanation: 'Explanation',
}



// WEBPACK FOOTER //
// ./src/common/lang/en/p1.js